import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Virtual Try-on";
const PROMPT_DOCUMENT_ID = "x1c58m9zxl8zt255ubcd8cj4";

const callVirtualTryOnV2 = async (
	base64Ref: string[],
	messageId: string,
	jwt: string,
	tool_document_id: string,
	batch_size: number,
	prompt_index: number,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				prompt_document_id: PROMPT_DOCUMENT_ID,
				prompt_index,
				input_images: [imageBase64, ...base64Ref],
				from_editor: true,
				jwt,
				tool_document_id,
				batch_size,
			};
			return fetchVirtualTryOnV2(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchVirtualTryOnV2(
	params: {
		prompt_document_id: string;
		prompt_index: number;
		input_images: string[];
		from_editor: boolean;
	},
	executionContext: any,
	messageId: string,
): Promise<string | string[] | false> {
	return fetchInferenceJob({
		params,
		executionContext,
		messageId,
		apiPath: "/infer/oplux",
		statusEndpoint: (apiUrl, jobId) =>
			`${apiUrl.replace("/infer/oplux", "")}/status/${jobId}`,
		resultEndpoint: (apiUrl, jobId) =>
			`${apiUrl.replace("/infer/oplux", "")}/result/${jobId}`,
		cancelEndpoint: (apiUrl, jobId) => ({
			url: `${apiUrl.replace("/infer/oplux", "")}/cancel/${jobId}`,
			method: "POST",
		}),
		extractResult: (data) => data.image_base64_list ?? [data.image_base64],
		useGatewayUrl: true,
	});
}

export function useListenVirtualTryOnV2Message() {
	useListenFromRenderer([
		{
			key: "virtualTryOnV2",
			onMessage: async (message) => {
				const success = await callVirtualTryOnV2(
					message.values.base64Ref,
					message.id,
					message.values.jwt,
					message.values.tool_document_id,
					message.values.batch_size,
					message.values.prompt_index,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
